import React from 'react'
import { resolveComponentForOperator } from 'components/ContactFilterBuilder/constants/PropertyComponents'

const HasOccurredExactly = ({ property, onChange, value }) => {

const PropertyComponent = resolveComponentForOperator(property.type, 'HAS_OCCURRED_EXACTLY')

return (
        <PropertyComponent
            property={property}
            onChange={onChange}
            value={value}
            isOperator={true}
        />
  )
}

export default HasOccurredExactly